<template>
	<v-card style="margin: 10px" v-if="bidderData">
		<v-card-title style="background-color: #0075e2; color: #fff">
			<h3>{{title}}</h3>
		</v-card-title>

		<v-card-text>
			<v-flex>
				<display-text-component
					:flex="'full-width'"
					label="Nazwa"
					:value="bidderData.polishName"/>
				<display-text-component
					:flex="'full-width'"
					label="Rodzaj"
					:value="getSector(getFormId(bidderData.legalForm))"/>
				<display-text-component
					:flex="'full-width'"
					label="Forma prawna"
					:value="bidderData.legalForm"/>
			</v-flex>

			<v-divider style="margin-top: 20px; margin-bottom: 20px"/>

			<v-layout row>
				<v-flex xs12>
					<display-text-component
						:flex="'full-width'"
						v-if="getFullBidderHeadquarter !== ''"
						label="Adres siedziby"
						:value="getFullBidderHeadquarter"/>
					<display-text-component
						:flex="'full-width'"
						v-if="getFullBidderCorrespondenceAddress !== ''"
						label="Adres do korespondencji"
						:value="getFullBidderCorrespondenceAddress"/>
					<display-text-component
						:flex="'full-width'"
						label="Numer NIP"
						:value="bidderData.nip"/>
					<display-text-component
						:flex="'full-width'"
						label="Numer KRS"
						v-if="bidderData.krs"
						:value="bidderData.krs"/>
					<display-text-component
						:flex="'full-width'"
						label="Strona WWW"
						:value="bidderData.www"/>
					<display-text-component
						:flex="'full-width'"
						label="Email"
						:value="bidderData.email"/>
					<display-text-component
						:flex="'full-width'"
						label="Numer telefonu"
						:value="bidderData.phoneNumber"/>
					<display-text-component
						:flex="'full-width'"
						label="Nazwa rejestru"
						v-if="bidderData.evidenceType"
						:value="bidderData.evidenceType"/>
					<display-text-component
						:flex="'full-width'"
						label="Numer w rejestrze"
						v-if="bidderData.evidenceNumber"
						:value="bidderData.evidenceNumber"/>
				</v-flex>
			</v-layout>

			<v-divider style="margin-top: 20px; margin-bottom: 20px"/>

			<v-flex xs12>
				<contestOfferSummaryPersonalData
					class="mt-3"
					title="Osoba upoważniona do reprezentowania podmiotu"
					:name="bidderData.repName"
					:surname="bidderData.repSurname"
					:bidder-role="bidderData.repPosition"/>
				<v-divider style="margin-top: 20px; margin-bottom: 20px" v-if="secondRepPersonIsNotNull"/>
				<contestOfferSummaryPersonalData
					class="mt-3"
					v-if="secondRepPersonIsNotNull"
					title="Druga osoba upoważniona do reprezentowania podmiotu"
					:name="bidderData.secRepName"
					:surname="bidderData.secRepSurname"
					:bidder-role="bidderData.secRepPosition"/>
			</v-flex>
		</v-card-text>
	</v-card>
</template>

<script>
  import ContestOfferSummaryPersonalData from "./ContestOfferSummaryPersonalData";
  import displayTextComponent from "./DisplayTextComponent";
  import {getSectorByLegalFormId} from "@/utils/LegalFormSectorDictionary";
  import {getIdByLegalFormName} from "@/utils/LegalFormDictionary";

  export default {
    name: "ContestOfferSummaryBidderDetails",

    components: {
      ContestOfferSummaryPersonalData,
      displayTextComponent,
    },

    computed: {
      secondRepPersonIsNotNull: function () {
        return this.bidderData !== null && this.bidderData.secRepName !== "" &&
            this.bidderData.secRepSurname !== "" && this.bidderData.secRepPosition !== "";
      },
      getFullBidderCorrespondenceAddress: function () {
        if (!this.bidderData || !this.bidderData.correspondenceAddress) {
          return "";
        } else {
          return this.bidderData.correspondenceAddress;
        }
      },

      getFullBidderHeadquarter: function() {
        if (!this.bidderData || !this.bidderData.hqaddress) {
          return "";
        } else {
          return this.bidderData.hqaddress;
        }
      }
    },

    methods: {
      getSector(legalFormId) {
        return getSectorByLegalFormId(legalFormId);
      },

      getFormId(legalForm) {
        return getIdByLegalFormName(legalForm);
      },
    },

    props: {
      title: { required: true, type: String },
      bidderData: { required: true, type: Object }
    }
  };
</script>

<style scoped>
  @media print {
    .flex.xs12 > div,
    .flex.xs12 > div > .v-card.v-sheet {
      page-break-inside: avoid !important;
    }
  }
</style>